import { z } from "zod/v4";

export const userSchema = z
	.union([
		z.string().transform((str) => JSON.parse(str)),
		z.object({
			id: z.string(),
			name: z.string(),
			profilePicture: z.string().optional(),
		}),
	])
	.pipe(
		z.object({
			id: z.string(),
			name: z.string(),
			profilePicture: z.string().optional(),
		})
	);

export type User = z.infer<typeof userSchema>;
